import type { FaireProductEntity } from "../../entity_types/product";

export const caden_lane_13: FaireProductEntity = {
  token: "caden-lane-13",
  type: "product",
  name: "CuddleLane™ Luxe Blankets | Gingerbread*",
  brandName: "Caden Lane",
  imageUrl:
    "https://cdn.faire.com/fastly/5d155c1018063210dbf03450ce91db6e885642e6412f014f5a49ff790085b8cf.jpeg?bg-color=FFFFFF&dpr=1&fit=crop&format=jpg&height=720&width=720",
  priceDollars: 26,
  msrpDollars: 52,
  freeShipping: false,
  isBestseller: false,
  description: "",
  tags: [],
  inStock: true,
  categoryTokens: ["cat_home-decor-bedding"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-products-migration",
  },
};
